export function showLoading(state) {
    state.isLoading = true;
}

export function hideLoading(state) {
    state.isLoading = false;
}